module.exports = __webpack_public_path__ + "static/img/cal.8a87ca8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/cal.jpg
// module id = JujK
// module chunks = 6